export default __webpack_public_path__ + "static/media/RetinaDisplay.a61be293.png";